const TrashIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="trash-can 1" clipPath="url(#clip0_180_832)">
        <path
          id="Vector"
          d="M10.875 1.5H8.625L7.8368 0.451172C7.62656 0.166992 7.29141 0 6.9375 0H5.0625C4.70859 0 4.37344 0.166992 4.1625 0.451172L3.375 1.5H1.125C0.918773 1.5 0.75 1.66875 0.75 1.875C0.75 2.08123 0.918773 2.25 1.125 2.25H10.875C11.0813 2.25 11.25 2.08123 11.25 1.875C11.25 1.66875 11.0813 1.5 10.875 1.5ZM4.3125 1.5L4.76367 0.899531C4.83516 0.805781 4.94531 0.75 5.0625 0.75H6.9375C7.05469 0.75 7.16602 0.805664 7.23633 0.899414L7.6875 1.5H4.3125ZM10.125 3C9.91875 3 9.75 3.16875 9.75 3.375V10.125C9.75 10.7454 9.24539 11.25 8.625 11.25H3.375C2.75461 11.25 2.25 10.7461 2.25 10.125V3.375C2.25 3.16875 2.08219 3 1.875 3C1.66781 3 1.5 3.16875 1.5 3.375V10.125C1.5 11.1586 2.34117 12 3.375 12H8.625C9.65883 12 10.5 11.1588 10.5 10.125V3.375C10.5 3.16875 10.3313 3 10.125 3ZM4.125 9.75V4.5C4.125 4.29272 3.95728 4.125 3.75 4.125C3.54272 4.125 3.375 4.29375 3.375 4.5V9.75C3.375 9.95728 3.54272 10.125 3.75 10.125C3.95728 10.125 4.125 9.95625 4.125 9.75ZM6.375 9.75V4.5C6.375 4.29272 6.20728 4.125 6 4.125C5.79272 4.125 5.625 4.29375 5.625 4.5V9.75C5.625 9.95728 5.79272 10.125 6 10.125C6.20728 10.125 6.375 9.95625 6.375 9.75ZM8.625 9.75V4.5C8.625 4.29272 8.45728 4.125 8.25 4.125C8.04272 4.125 7.875 4.29375 7.875 4.5V9.75C7.875 9.95728 8.04272 10.125 8.25 10.125C8.45728 10.125 8.625 9.95625 8.625 9.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_180_832">
          <rect
            width="10.5"
            height="12"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrashIcon;
